import React from "react";
import { connect } from "react-redux";
import language from "../../language";
import { Table } from "../Table";
import handleSearch from "../../utils/handleSearch";
import { getStorage } from "../../utils/storage";
import { fetchTransactionsReversalsSummary } from "../../queries/reports/transactionsQuery";
import icons from "../../constants/icons";
import { Modal } from "../Modal";
import SingleTransactionView from "./SingleTransactionView";

let copyData = [];

class TransactionsRefundSummary extends React.Component {
  state = {
    isLoading: false,
    data: [],
    search_text: "",
    selected_data: {},
    error: {},
    user: {},
    page: 0,
    limit: 10,
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });

    this.getData(true);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.filters !== this.props.filters) {
      this.setState({ page: 0 });
      this.getData(true);
    }
  }

  filtersParams = async () => {
    let { filters = {} } = this.props;
    const { page, limit, user } = this.state;

    const { merchantID } = await getStorage("merchantID");

    let params = {
      merchantId: merchantID,
      page,
      size: limit,
    };

    if (filters.transactionStatus) {
      params.transactionResult = filters.transactionStatus.value;
    }

    if (filters.paymentMode) {
      params.paymentMode = filters.paymentMode.value;
    }

    if (filters.startDate && filters.endDate) {
      params.startDate = filters.startDate;
      params.endDate = filters.endDate;
    }

    if (filters.transactionSubType) {
      params.transactionSubType = filters.transactionSubType.value;
    }
    return params;
  };

  getData = async (isLoading) => {
    const { defaultLanguage } = this.props;
    const params = await this.filtersParams();
    try {
      this.setState({ isLoading });

      const { content = [], totalPages } =
        await fetchTransactionsReversalsSummary(defaultLanguage, params);

      this.setState({
        isLoading: false,
        data: content,
        totalPageCount: totalPages,
      });

      copyData = content.slice(0);
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e.target.value,
      error,
    });
  }

  handlePagination(page) {
    this.setState(
      {
        page,
      },
      () => {
        this.getData(true);
      }
    );
  }

  handleShowModal(modal, modalTitle, selected_data = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selected_data,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].date,
        key: "date",
        isMoment: true,
        formatTime: "lll",
      },
      {
        title: language[this.props.defaultLanguage].merchant,
        key: "merchant.name",
      },
      {
        title: language[this.props.defaultLanguage].transaction_type,
        key: "transactionType",
      },
      {
        title: language[this.props.defaultLanguage].amount,
        key: "amount",
      },
      {
        title: language[this.props.defaultLanguage].count,
        key: "count",
      },
      {
        title: language[this.props.defaultLanguage].transaction_result,
        key: "transactionResult",
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "multiple-actions",
        actions: [
          {
            icon: icons.eye_on,
            title: language[this.props.defaultLanguage].view,
            onPress: (item) =>
              this.handleShowModal(
                "showModal",
                `Transaction ${item.processorTransactionId}`,
                item
              ),
          },
        ],
      },
    ];

    return headers;
  }

  render() {
    return (
      <>
        <div className="card">
          <div className="card-body">
            <Table
              data={this.state.data}
              isSearch
              page={this.state.page}
              limit={this.state.limit}
              search_text={this.state.search_text}
              handleSearch={(e) =>
                handleSearch(this, {
                  copyData,
                  value: e.target.value,
                })
              }
              totalPageCount={this.state.totalPageCount}
              isLoading={this.state.isLoading}
              handlePagination={this.handlePagination.bind(this)}
              headers={this.returnTableHeaders()}
              rowPress={(item) =>
                this.handleShowModal(
                  "showModal",
                  `Transaction ${item.processorTransactionId}`,
                  item
                )
              }
              filters={[
                {
                  title:
                    language[this.props.defaultLanguage].transaction_status,
                  button_type: "dropdown",
                  icon: icons.receipt,
                  filterName: "transactionStatus",
                },
                {
                  title: language[this.props.defaultLanguage].payment_mode,
                  button_type: "dropdown",
                  icon: icons.card,
                  filterName: "paymentMode",
                },
                {
                  title:
                    language[this.props.defaultLanguage].transaction_sub_type,
                  button_type: "dropdown",
                  icon: icons.transaction,
                  filterName: "transactionSubType",
                },
                {
                  title: language[this.props.defaultLanguage].date_range,
                  button_type: "dropdown",
                  icon: icons.calendar,
                  filterName: "date",
                },
              ]}
            />
          </div>
        </div>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
          size="lg"
        >
          <SingleTransactionView
            handleCloseModal={this.handleCloseModal.bind(this, "showModal")}
            transaction={this.state.selected_data}
          />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { filters } = state.Filters;
  return {
    defaultLanguage,
    filters,
  };
};

export default connect(mapStateToProps)(TransactionsRefundSummary);
